// The access token lives only in this module variable: it is never written to
// localStorage or the URL, so a page reload drops it and the session is
// restored through POST /auth/refresh (see AuthService.restoreSession).
let accessToken = null;

export function getToken() {
    return accessToken;
}

export function setToken(token) {
    accessToken = token || null;
}

export function clearToken() {
    accessToken = null;
}
